import { FC } from 'react';
import { CustomAlert, CustomButton, Text } from '../../../../shared/uiComponents';
import { TEXT } from '../../../../shared/Helpers/colors';
import { UNSAVED_TARGET_DATA_WARNING } from '../../../../shared/Helpers/constants';

interface UnsavedTargetsWarningProps {
	onCancel: () => void;
	onConfirm: () => void;

	open: boolean;
}

const UnsavedTargetsWarningContent: FC<{
	onClose: () => void;
	onConfirm: () => void;
}> = ({ onClose, onConfirm }) => (
	<div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
		<Text title={UNSAVED_TARGET_DATA_WARNING} type="psm" color={TEXT.SECONDARY} />
		<div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
			<CustomButton title="Cancel" buttonType="secondaryGray" onClick={onClose} sizeType="lg" />
			<CustomButton title="Leave Anyway" buttonType="primary" onClick={onConfirm} sizeType="lg" />
		</div>
	</div>
);

const UnsavedTargetsWarning: FC<UnsavedTargetsWarningProps> = ({ open, onCancel, onConfirm }) => (
	<CustomAlert
		open={open}
		onClose={onCancel}
		title="Unsaved Changes"
		Content={({ onClose }) => <UnsavedTargetsWarningContent onClose={onClose} onConfirm={onConfirm} />}
		maxWidth="xs"
	/>
);

export default UnsavedTargetsWarning;
